export async function clearStytchCookies(): Promise<void> {
  if (typeof document === 'undefined') {
    return;
  }

  const cookieNames = document.cookie
    .split(';')
    .map((chunk) => chunk.trim().split('=')[0])
    .filter((name) => name.toLowerCase().startsWith('stytch_session'));

  if ('cookieStore' in window && typeof (window as any).cookieStore?.delete === 'function') {
    const store = (window as any).cookieStore as {
      delete: (name: string) => Promise<void>;
    };

    await Promise.all(
      cookieNames.map(async (name) => {
        try {
          await store.delete(name);
        } catch {
          // Best effort; fall through to document.cookie cleanup.
        }
      })
    );
  }

  // Compute the parent domain (e.g. ".mento.co") so we clear cookies set on
  // both the exact hostname and the parent domain (StytchProvider sets cookies
  // on the parent domain via cookieOptions.domain).
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const parts = hostname.split('.');
  const parentDomain = parts.length >= 2 ? `.${parts.slice(-2).join('.')}` : '';

  cookieNames.forEach((name) => {
    // Clear on the exact hostname (default when domain is omitted)
    document.cookie = `${name}=; Max-Age=0; path=/`;
    // Clear on the parent domain (e.g. .mento.co) if applicable
    if (parentDomain) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${parentDomain}`;
    }
  });
}

export default clearStytchCookies;
